import createTag from './createTag';
import handleClick from './handleClick';
import idle from './idle';

/**
 * @function render
 * @description render the widget
 * @param {any} data
 */
export default function render(data) {
    const module = data.config.module;

    const id = document.getElementById(`app-emi-${module}`);

    // check if the module was already rendered, if so, empty the container element
    const destroy = document.querySelector(`[data-emi-${module}-table]`);
    if (destroy) id.innerHTML = '';

    /* ul.table */
    const ul = createTag(
        'ul',
        `data-emi-${module}-table`,
        '',
        Object.keys(data.config.css)
            .filter(function (key) {
                return data.config.css[key];
            })
            .join(' ')
    );
    ul.setAttribute('data-emi-module', data.config.module || 'no-module');
    ul.setAttribute(`data-emi-${module}-shape`, data.config.shape || 'no-shape');
    ul.setAttribute(`data-emi-${module}-speed`, data.config.speed || 'no-speed');
    id.prepend(ul);

    /* h2.title */
    if (data.title.start) {
        const titleStart = createTag('h2', `data-emi-${module}-title`, 'start');
        titleStart.innerHTML = data.title.start;
        id.prepend(titleStart);
    }
    if (data.title.end) {
        const titleEnd = createTag('h2', `data-emi-${module}-title`, 'end');
        titleEnd.innerHTML = data.title.end;
        id.prepend(titleEnd);
    }

    var fragment = document.createDocumentFragment();

    // create the tarot deck
    data.deck.forEach(function (item, index) {
        /* li.scene */
        const li = createTag('li', `data-emi-${module}-scene`, index);
        fragment.appendChild(li);

        if (data.config.pile) {
            li.style.transform = `
                translateY(${data.config.pile[index][0] + 75}px)
                translateX(calc(20% + ${data.config.pile[index][1] - 50}px))
                rotate(${index * Math.floor(Math.random() * 50) + 1}deg)
            `;
        }

        /* a.item */
        const a = createTag('a', `data-emi-${module}-item`, '');
        a.setAttribute('href', '#');
        a.setAttribute('role', 'button');

        a.onclick = function (e) {
            e.preventDefault();
            handleClick(data, this, index, data.config.duration);
        };
        li.appendChild(a);

        // trigger idle animation
        if (data.config.animation) {
            window.setTimeout(function () {
                idle(li);
            }, index * 100);
            window.setInterval(function () {
                window.setTimeout(function () {
                    idle(li);
                }, index * 100);
            }, 100 * (data.deck.length + 2));
        }

        /* img */
        const imgFront = createTag('img', `data-emi-${module}-front`, '');
        imgFront.setAttribute('src', item.source), a.appendChild(imgFront);

        /* img.frame */
        if (data.frame) {
            const frame = createTag('img', `data-emi-${module}-frame`, '');
            frame.setAttribute('src', data.frame.source);
            a.appendChild(frame);
        }

        const imgBack = createTag('img', `data-emi-${module}-back`, '');
        imgBack.setAttribute('src', data.back.source), a.appendChild(imgBack);

        const imgPlaceholder = createTag('img', `data-emi-${module}-placeholder`, '');
        imgPlaceholder.setAttribute('src', data.back.source), li.appendChild(imgPlaceholder);
    });

    ul.appendChild(fragment);

    // Listen to Maestro by subscribing to the event bus
    Maestro.getInstance().Store.save(`${module}-status`, { initialized: true });
    Maestro.getInstance()
        .EventBus.on(`${module}-stop`, () => {
            // Stop the module
            data.stop();
            data.log();
            id.classList.add('status--disabled');
        })
        .on(`${module}-start`, (e) => {
            // Restart the module
            data.start();
            data.log();
            id.classList.remove('status--disabled');
        });

    console.timeEnd('render_time');
}
